import { Modal } from 'antd';
import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';

export const wipModalIfToggleOn = (toggle, onToggleOff) => {
  const prefix = 'landlordPortal.applicationManagement.wipModal';

  if (featureEnabled(toggle)) {
    return Modal.info({
      title: getTranslatedString(`${prefix}.Title`),
      content: getTranslatedString(`${prefix}.Content`),
    });
  }

  return onToggleOff();
};

export const phaseOneWip = (onToggleOff) => {
  return wipModalIfToggleOn('4-0-phase-1-wip', onToggleOff);
};

export const phaseTwoWip = (onToggleOff) => {
  return wipModalIfToggleOn('4-0-phase-2-wip', onToggleOff);
};

export const phaseThreeWip = (onToggleOff) => {
  return wipModalIfToggleOn('4-0-phase-3-wip', onToggleOff);
};

export const leaseManagementWip = (onToggleOff) => {
  return wipModalIfToggleOn('4-0-lease-management', onToggleOff);
};

export const wipAction = () => {
  const prefix = 'landlordPortal.applicationManagement.wipModal';

  return Modal.info({
    title: getTranslatedString(`${prefix}.Title`),
    content: getTranslatedString(`${prefix}.Content`),
  });
};
